import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class QualityReferenceQueryService {

    public GET_REFERENCES_DATA: any;

    constructor(public apollo: Apollo) {

        this.GET_REFERENCES_DATA =
            gql`
           query currentScheduleRequests($userId:UUID){                           
                allQualityReferences(condition:{userId:$userId}) {
                    nodes {
                        name
                        email
                        phone
                        userId
                    }
                }
            }
        `  ;
    }


    FETCH_REFERENCES(userId): any {
        return this.apollo
            .watchQuery({
                query: this.GET_REFERENCES_DATA
                ,
                variables:
                {
                    "userId": userId
                },
                fetchPolicy: 'network-only'
            });
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/qualityReference.ts